<template>
  <div class="team-introduction-wrapper">
    <img class="team-introduction-title" :src="source('team-introduction')" />

    <div class="team-list-wrapper" ref="teamListRef">
      <div class="item" v-for="(item, index) in teamList" :key="index" @click="toPage('/team')">
        <img class="bg" :src="item.src" alt="" draggable="false">
        <div class="team-mask">
          <img :src="item.titleSrc" alt="" draggable="false">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'team-introduction',
  data() {
    return {
      teamList: [
        { src: this.source('new-team1'), titleSrc: this.source('new-team1-title') },
        { src: this.source('new-team2'), titleSrc: this.source('new-team2-title') },
        { src: this.source('new-team3'), titleSrc: this.source('new-team3-title') },
        { src: this.source('new-team4'), titleSrc: this.source('new-team4-title') },
        { src: this.source('new-team5'), titleSrc: this.source('new-team5-title') },
      ],
      // 鼠标是否在长按点击
      flag: false,
      // 鼠标点击下的位置信息
      downX: 0,
      // 首次点击滚顶条位置信息
      scrollLeft: 0,
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME_TEAM, name).fileUrl
    },
    obsAnimation(el, fun, isUnobserve = false) {
      const ob = new IntersectionObserver(e => {
        if (!e[0].isIntersecting) return
        fun(el)
        if (isUnobserve) ob.unobserve(el)
      })
      ob.observe(el)
    },
    listAnimation() {
      this.obsAnimation(this.$refs.teamListRef, (el) => {
        for (let i = 0; i < el.children.length; i++) {
          el.children[i].style.transform = 'translateY(0)'
          el.children[i].style.transitionDelay = `${i * 200}ms`
        }
      }, false)
    }
  },
  mounted() {
    this.listAnimation()
  }
}
</script>

<style scoped lang="scss">
.team-introduction-wrapper {
  position: relative;
  width: 100vw;
  height: 56.25vw;
  overflow: hidden;
  background-color: black;

  .team-introduction-title {
    width: 2.34vw;
    height: 33.38vw;
    position: absolute;
    left: 10vw;
    top: 5.6vw;
  }

  .team-list-wrapper {
    width: 85vw;
    height: 50.73vw;
    position: absolute;
    right: 0px;
    bottom: 0px;
    overflow: hidden;
    display: flex;

    .item {
      margin-left: 0.8vw;
      width: 16.20vw;
      height: 50.73vw;
      transition: all 1s linear;
      transform: translateY(40vw);
      overflow: hidden;

      &:first-child{
        margin-left: 0px;
      }

      &:hover img{
        transition: all .3s;
        transform: scale(1.06);
      }

      .team-mask {
        position: absolute;
        left: 0vw;
        bottom: 0vw;
        opacity: 1;
        width: 100%;
        height: 100%;
        cursor: pointer;
        //transition: all .3s ease-in-out;

        //&:hover {
        //  opacity: 1;
        //}

        img {
          width: 14.48vw;
          height: 9.74vw;
          position: absolute;
          left: 1.3vw;
          bottom: 2vw;
        }
      }
    }
  }
}
</style>
